/**
 * Ratomeet configuration for Fitnova video calls
 * Signaling server lives in /Ratomeet/server
 */

const config = {
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL || 'http://localhost:3100',

  ICE_SERVERS: {
    iceServers: [
      { urls: 'stun:stun.l.google.com:19302' },
      { urls: 'stun:stun1.l.google.com:19302' },
      {
        urls: process.env.REACT_APP_TURN_URL || 'turn:51.20.64.62:3478',
        username: process.env.REACT_APP_TURN_USERNAME || 'ratomeet',
        credential: process.env.REACT_APP_TURN_CREDENTIAL || 'Ratovate@2026!',
      },
    ],
    iceCandidatePoolSize: 10,
  },

  VIDEO_CONSTRAINTS: {
    width: { min: 640, ideal: 1280, max: 1920 },
    height: { min: 480, ideal: 720, max: 1080 },
    facingMode: 'user',
    frameRate: { ideal: 30 },
  },

  AUDIO_CONSTRAINTS: {
    echoCancellation: true,
    noiseSuppression: true,
    autoGainControl: true,
    sampleRate: 48000,
  },

  RECONNECT_ATTEMPTS: 5,
  RECONNECT_DELAY: 3000,
};

export default config;
